var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletconnectLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1024,
    zoomAndPan: "magnify",
    viewBox: "0 0 768 767.999994",
    height: 1024,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "75714f47ea"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 75 L 0 693 C 0 734.421875 33.578125 768 75 768 L 693 768 C 734.421875 768 768 734.421875 768 693 L 768 75 C 768 33.578125 734.421875 0 693 0 L 75 0 C 33.578125 0 0 33.578125 0 75 Z M 0 75 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "09bd02ce76"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 91 205 L 679 205 L 679 564 L 91 564 Z M 91 205 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8fcfbfe529"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 75 L 0 693 C 0 734.421875 33.578125 768 75 768 L 693 768 C 734.421875 768 768 734.421875 768 693 L 768 75 C 768 33.578125 734.421875 0 693 0 L 75 0 C 33.578125 0 0 33.578125 0 75 Z M 0 75 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#75714f47ea)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -76.8,
    width: 921.6,
    fill: "#3396ff",
    y: -76.799999,
    height: 921.599993,
    fillOpacity: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#09bd02ce76)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8fcfbfe529)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 211.722656 275.546875 C 307.488281 182.152344 462.761719 182.152344 558.527344 275.546875 L 570.054688 286.785156 C 574.84375 291.453125 574.84375 299.027344 570.054688 303.695312 L 530.625 342.144531 C 528.230469 344.480469 524.351562 344.480469 521.957031 342.144531 L 506.09375 326.675781 C 439.285156 261.523438 330.964844 261.523438 264.15625 326.675781 L 247.167969 343.242188 C 244.773438 345.574219 240.894531 345.574219 238.5 343.242188 L 199.070312 304.789062 C 194.28125 300.121094 194.28125 292.550781 199.070312 287.882812 Z M 640.070312 355.0625 L 675.160156 389.285156 C 679.945312 393.953125 679.945312 401.523438 675.160156 406.191406 L 516.929688 560.496094 C 512.144531 565.167969 504.382812 565.167969 499.59375 560.496094 L 387.292969 450.984375 C 386.097656 449.816406 384.15625 449.816406 382.957031 450.984375 L 270.660156 560.496094 C 265.875 565.167969 258.109375 565.167969 253.320312 560.496094 L 95.089844 406.191406 C 90.304688 401.523438 90.304688 393.949219 95.089844 389.28125 L 130.183594 355.0625 C 134.96875 350.390625 142.734375 350.390625 147.523438 355.0625 L 259.824219 464.578125 C 261.019531 465.742188 262.960938 465.742188 264.15625 464.578125 L 376.453125 355.0625 C 381.238281 350.390625 389.003906 350.390625 393.792969 355.0625 L 506.09375 464.578125 C 507.289062 465.742188 509.230469 465.742188 510.429688 464.578125 L 622.730469 355.0625 C 627.515625 350.390625 635.277344 350.390625 640.070312 355.0625 Z M 640.070312 355.0625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletconnectLogo);
export default __webpack_public_path__ + "static/media/walletconnect-logo.56b4c81c1566ccee9cfc6de29a9d63a8.svg";
export { ForwardRef as ReactComponent };